"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import React, { Fragment, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
export default function CookieBanner() {
    var _useState = _sliced_to_array(useState(false), 2), openModalFlag = _useState[0], setOpenModal = _useState[1];
    var _useCookies = _sliced_to_array(useCookies([
        "gatsby-gdpr-google-tagmanager",
        "cookie-agreed"
    ]), 2), cookies = _useCookies[0], setCookie = _useCookies[1];
    // Try to read cookie from previous site, same domain
    var cookieAgreed = parseInt(cookies["cookie-agreed"]) == 2 ? true : false;
    var cookieRejected = parseInt(cookies["cookie-agreed"]) == 0 ? true : false;
    var closeModal = function() {
        setGTACookie(false);
        setOpenModal(false);
    };
    useEffect(function() {
        if (cookieAgreed) {
            setCookie("gatsby-gdpr-google-tagmanager", true, {
                path: "/",
                expires: new Date(Date.now() + 60 * 60 * 24 * 365 * 1000)
            });
        } else if (cookieRejected) {
        // do nothing
        } else if (cookies["cookie-agreed"] == undefined) {
            setOpenModal(true);
        }
    }, []);
    var setGTACookie = function(value) {
        setOpenModal(false);
        if (value === true) {
            setCookie("gatsby-gdpr-google-tagmanager", value, {
                path: "/",
                expires: new Date(Date.now() + 60 * 60 * 24 * 365 * 1000)
            });
            // No need to add the hs script here, is added from GTM
            // Set also the cookie-agreed
            setCookie("cookie-agreed", 2, {
                path: "/",
                expires: new Date(Date.now() + 60 * 60 * 24 * 365 * 1000)
            });
        } else {
            setCookie("gatsby-gdpr-google-tagmanager", value, {
                path: "/"
            });
            setCookie("cookie-agreed", 0, {
                path: "/"
            });
        }
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Transition, {
        appear: true,
        show: openModalFlag,
        as: Fragment
    }, /*#__PURE__*/ React.createElement(Dialog, {
        as: "div",
        className: "relative z-[26]",
        "aria-label": "Cookie settings",
        onClose: closeModal
    }, /*#__PURE__*/ React.createElement(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "fixed inset-0 bg-black bg-opacity-70"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "fixed inset-0 overflow-y-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex min-h-full items-center justify-center p-4 text-center"
    }, /*#__PURE__*/ React.createElement(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0 scale-95",
        enterTo: "opacity-100 scale-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-95"
    }, /*#__PURE__*/ React.createElement(Dialog.Panel, {
        className: "max-w-sm bg-white relative text-left align-middle transition-all"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "py-3 px-5 text-white text-lg bg-gray-900"
    }, /*#__PURE__*/ React.createElement("strong", null, "Cookie Settings")), /*#__PURE__*/ React.createElement("div", {
        className: ""
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: closeModal,
        className: "text-white focus:outline-none absolute top-3.5 right-3",
        "aria-label": "Close cookie settings modal"
    }, /*#__PURE__*/ React.createElement(XMarkIcon, {
        className: "w-6 h-6"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "prose"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "bg-gray-25 p-5 text-gray-600"
    }, "We use cookies and similar technologies to improve user experience and analyze website traffic. For these reasons, we may share your site usage data with our analytics partners. If you do not wish this,", " ", /*#__PURE__*/ React.createElement("a", {
        className: "cursor-pointer",
        onClick: function() {
            return setGTACookie(false);
        }
    }, "click here"), ". For more information read our", " ", /*#__PURE__*/ React.createElement("a", {
        href: "/privacy-policy",
        target: "_blank"
    }, "privacy policy"), ".")), /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-center py-6"
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: function() {
            return setGTACookie(true);
        },
        className: "button-primary text-sm focus bg-yellow-500 text-gray-600 border border-yellow-500 hover:border-gray-600 hover:bg-gray-600 hover:text-white"
    }, "Accept and close")))))))));
}
